import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  QRStatusColorPipe,
  QRStatusIconPipe,
  QRStatusTooltipPipe,
  SRStatusColorPipe,
  SRStatusIconPipe,
  SRStatusTooltipPipe,
} from "@gloria-public/home/domain/pipes/home-page.pipe";
import { PredispositionComponent } from "@gloria-public/home/views/home-page/components/predisposition/predisposition.component";
import { PredispositionsTableComponent } from "@gloria-public/home/views/home-page/components/predispositions-table/predispositions-table.component";
import { QRPredispositionComponent } from "@gloria-public/home/views/home-page/components/qr-predisposition/qr-predisposition.component";
import { SRPredispositionComponent } from "@gloria-public/home/views/home-page/components/sr-predisposition/sr-predisposition.component";
import { CarouselModule } from "@shared/components/carousel/carousel.module";
import { SearchRiskTagsModule } from "@shared/components/search-risk-tags/search-risk-tags.module";
import { LocalizedDatePipe } from "@shared/pipes/localized-date.pipe";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { TranslationValuePipe } from "@shared/utils/helpers/translation-value.pipe";
import { notOrderedRiskTableComponent } from "./components/not-ordered-risk-table/not-ordered-risk-table.component";
import { HomePageComponent } from "./home-page.component";
import { RouterModule } from "@angular/router";

const materialModules = [
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatSelectModule,
  MatTableModule,
  MatPaginatorModule,
  MatIconModule,
  MatButtonModule,
];

@NgModule({
  declarations: [
    HomePageComponent,
    SRStatusIconPipe,
    SRStatusTooltipPipe,
    SRStatusColorPipe,
    QRStatusIconPipe,
    QRStatusTooltipPipe,
    QRStatusColorPipe,
    PredispositionsTableComponent,
    PredispositionComponent,
    QRPredispositionComponent,
    SRPredispositionComponent,
    notOrderedRiskTableComponent,
  ],
  providers: [],
  imports: [
    CommonModule,
    CommonTranslateModule,
    SearchRiskTagsModule,
    LocalizedDatePipe,
    CarouselModule,
    TranslationValuePipe,
    RouterModule,
    ...materialModules,
  ],
})
export class HomePageModule {}
